var carouselTypes = {
  SIMILAR_ITEMS: "SIMILAR_ITEMS",
  OUTFITS: "OUTFITS",
  VISUALLY_SIMILAR_TO: "VISUALLY_SIMILAR_TO",
  RECENTLY_VIEWED: "RECENTLY_VIEWED",
  COLLECTION: "COLLECTION",
  CLEARANCE: "CLEARANCE",
  RECOMMENDATION: "RECOMMENDATION",
  STYLE_PERSONA_RECOMMENDATIONS: "STYLE_PERSONA_RECOMMENDATIONS",
  DESIGNER_RECOMMENDATIONS: "DESIGNER_RECOMMENDATIONS",
  SIMILAR_DESIGNERS_RECOMMENDATIONS: "SIMILAR_DESIGNERS_RECOMMENDATIONS",
  NECKLINE_RECOMMENDATIONS: "NECKLINE_RECOMMENDATIONS",
  EMBELLISHMENT_RECOMMENDATIONS: "EMBELLISHMENT_RECOMMENDATIONS",
  DEAD_END_SEARCH: "DEAD_END_SEARCH",
};

export default carouselTypes;

export const { SIMILAR_ITEMS, OUTFITS, VISUALLY_SIMILAR_TO, RECENTLY_VIEWED, SIMILAR_DESIGNERS_RECOMMENDATIONS } =
  carouselTypes;
